/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_DescriptionInputs */

const en_tables_custom_pages_description = /** @type {(inputs: Tables_Custom_Pages_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Description`)
};

const de_tables_custom_pages_description = /** @type {(inputs: Tables_Custom_Pages_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Pages Description" |
*
* @param {Tables_Custom_Pages_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_description = /** @type {((inputs?: Tables_Custom_Pages_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_description(inputs)
	return de_tables_custom_pages_description(inputs)
});